const en = {
  "nav.services": "Services",
  "nav.story": "About",
  "nav.process": "How it works",
  "nav.faq": "FAQ",
  "nav.contact": "Contact",
  "nav.call": "+598 93 855 338",

  "seo.title": "Facundo Yoldi | Home nurse in Maldonado & Punta del Este",
  "seo.desc": "Home nursing in Maldonado and Punta del Este within 20 km: monitoring, wound care, injections and post-surgical care. WhatsApp +598 93 855 338.",

  "beat1.stamp": "01 — Home nursing",
  "beat1.h1": "Care at home,<br>in <em class=\"accent\">skilled</em> hands.",
  "beat1.sub": "Licensed nurse. Home care in Maldonado, Punta del Este and within 20 km.",
  "beat1.local": "Home nursing in Maldonado & Punta del Este",
  "beat1.cta": "Request a visit",

  "beat2.stamp": "02 — Services at home",
  "beat2.h2a": "Checks, dressings",
  "beat2.h2b": "and <em class=\"accent\">company</em>.",
  "beat2.sub": "Medication on time, recovery at home, family at peace.",
  "beat2.chip1": "Blood pressure & glucose",
  "beat2.chip2": "Wound care & injections",
  "beat2.chip3": "Post-surgical care",

  "beat3.quote": "Care is never improvised.",
  "beat3.stamp": "Facundo Yoldi · Registered nurse",

  "beat4.stamp": "04 — Contact & booking",
  "beat4.h2": "Let's plan your<br>first <em class=\"accent\">visit</em> today.",
  "beat4.sub": "WhatsApp +598 93 855 338 — we answer the same day.",
  "beat4.cta": "Book a visit",

  "manifesto": "The best recovery never happens in a hospital corridor. It happens at home, with someone who knows how to <em class=\"accent\">look</em> in time.",

  "story.stamp": "02 — About",
  "story.h2": "One nurse,<br>not an <em class=\"accent\">agency</em>.",
  "story.sub": "Facundo Yoldi is a registered nurse and always works in person. The same person who walks through your door follows your clinical history: he knows your medication, your home and your family, and nothing has to be explained twice.",
  "story.point1": "Continuous follow-up with a single professional.",
  "story.point2": "Written report to the family after every visit.",
  "story.point3": "Referral to the treating doctor when needed.",
  "story.imageAlt": "Nurse pulling on blue gloves at the doorway of a home",

  "services.stamp": "03 — Services",
  "services.h2": "Everything that happens<br>in a <em class=\"accent\">home</em>.",
  "services.sub": "Visits of 45 to 60 minutes, supplies included.",
  "services.s1t": "Monitoring",
  "services.s1d": "Blood pressure, glucose, oxygen. Every reading recorded at each visit.",
  "services.s2t": "Wound care",
  "services.s2d": "Wounds, ulcers and burns handled with sterile material.",
  "services.s3t": "Medication & injections",
  "services.s3d": "IV, intramuscular or subcutaneous, as prescribed.",
  "services.s4t": "Post-surgical care",
  "services.s4d": "Dressing changes, drains and pain control.",
  "services.imageAlt": "Nurse taking the blood pressure of an older woman in her living room",

  "numbers.title": "In numbers",
  "numbers.n1": "Years of practice",
  "numbers.n1c": "In hospital and at home.",
  "numbers.n2": "Home visits",
  "numbers.n2c": "Since 2019, in Maldonado and Punta del Este, within a 20 km radius.",
  "numbers.n3": "Response",
  "numbers.n3c": "Same day, over WhatsApp.",
  "numbers.n4": "Rating",
  "numbers.n4c": "Average from the families we serve.",

  "process.stamp": "05 — How it works",
  "process.h2": "From a message<br>to a <em class=\"accent\">visit</em>.",
  "process.sub": "No long paperwork: three steps and we're at your door.",
  "process.p1": "You send a WhatsApp",
  "process.p1d": "Tell us the case, the address and the schedule that suits the family.",
  "process.p2": "We schedule an assessment",
  "process.p2d": "A first visit to understand the situation and build the plan.",
  "process.p3": "Follow-up begins",
  "process.p3d": "Scheduled visits and a report after each one.",
  "process.imageAlt": "Nurse beside a patient looking out a window at sunset",

  "faq.stamp": "06 — FAQ",
  "faq.h2": "What families<br>ask <em class=\"accent\">most</em>.",
  "faq.q1": "Which areas do you cover?",
  "faq.a1": "Maldonado, Punta del Este and a 20 km radius, Monday to Saturday. Outside that area, message us on WhatsApp and we'll see whether we can cover it.",
  "faq.q2": "How much does a visit cost?",
  "faq.a2": "It depends on the procedure and the frequency. We send you the exact price on WhatsApp before you book, with no surprises.",
  "faq.q3": "Do you handle emergencies?",
  "faq.a3": "We are not an emergency service. For emergencies call 911. We handle consultations and same-day scheduled visits when there is availability.",
  "faq.q4": "What's needed for the first visit?",
  "faq.a4": "The prescription or medical indication, previous tests and the treating doctor's details. Without a prescription we can still schedule an assessment.",
  "faq.q5": "Do you work with health insurers?",
  "faq.a5": "We work privately. We do issue documentation so you can submit it to your coverage if they accept it.",

  "reviews.stamp": "07 — Reviews",
  "reviews.nav": "Reviews",
  "reviews.h2": "What <em class=\"accent\">families</em><br>tell us.",
  "reviews.sub": "Reviews left on Google by patients and families in Maldonado and Punta del Este.",
  "reviews.score": "5.0",
  "reviews.scoreCap": "Average on Google",
  "reviews.count": "10 reviews · all five stars",
  "reviews.starsLabel": "5 out of 5 stars",
  "reviews.date": "3 months ago",
  "reviews.r1": "Excellent professional, highly recommended for all his work and attitude.",
  "reviews.r2": "Excellent professional! Excellent at giving injections! Highly recommended.",
  "reviews.r3": "Excellent service, very reliable and responsible. Truly recommendable, a very good experience.",
  "reviews.r4": "Excellent service and amazing support! Highly recommended.",
  "reviews.r5": "Excellent professional! Attentive and dedicated! Highly recommended.",
  "reviews.r6": "Responsible, committed, a trustworthy professional dedicated to healthcare. 100% recommended.",
  "reviews.r7": "Excellent professional, very warm and friendly.",
  "reviews.r8": "Excellent service.",

  "contact.stamp": "08 — Contact",
  "contact.h2": "Write to us and<br>we'll <em class=\"accent\">arrange</em> it.",
  "contact.sub": "Tell us what you need. We reply the same day, Monday to Saturday.",
  "contact.langNote": "We speak Spanish and English",
  "contact.talkLang": "Which language should we use with you?",
  "contact.name": "Full name",
  "contact.namePh": "Your name",
  "contact.phone": "Phone / WhatsApp",
  "contact.phonePh": "+598 93 855 338",
  "contact.email": "Email",
  "contact.emailPh": "name@email.com",
  "contact.zone": "Neighbourhood or town",
  "contact.zonePh": "e.g. Punta del Este, Maldonado",
  "contact.service": "Type of service",
  "contact.servicePh": "Choose an option",
  "contact.service1": "Monitoring",
  "contact.service2": "Wound care",
  "contact.service3": "Medication & injections",
  "contact.service4": "Post-surgical care",
  "contact.service5": "Something else",
  "contact.message": "Tell us about the case",
  "contact.messagePh": "A short description and the schedule that suits you (max. 500 characters)",
  "contact.submit": "Send enquiry",
  "contact.submitting": "Sending…",
  "contact.ok": "We got your message. We'll write to you today on WhatsApp.",
  "contact.err": "We couldn't send the form. Try again or message us on WhatsApp at +598 93 855 338.",
  "contact.fallbackTitle": "Don't retype it — send it on WhatsApp",
  "contact.fallbackText": "The form didn't go through, but nothing was lost. Tap below and the chat opens with your name, the service and your message already written.",
  "contact.fallbackBtn": "Send it on WhatsApp",
  "contact.waLeadEs": "Hola Facundo, te escribo desde la web porque no pude enviar el formulario.",
  "contact.waLeadEn": "Hi Facundo, I'm writing from the website because the form wouldn't send.",
  "contact.direct": "Or write to us directly",
  "contact.waBtn": "Open WhatsApp",
  "contact.waTextEs": "Hola Facundo, te escribo desde la web. Quería consultar por una visita de enfermería a domicilio.",
  "contact.waTextEn": "Hi Facundo, I'm writing from the website. I'd like to ask about a home nursing visit.",
  "contact.waHintEs": "The chat opens with the message already written in Spanish.",
  "contact.waHintEn": "The chat opens with the message already written in English.",

  "chat.hint": "I reply in English or Spanish — Facundo",
  "chat.hintClose": "Hide this note",

  "footer.tag": "Home nursing",
  "footer.desc": "Professional nursing care in your own home, with follow-up and a human touch.",
  "footer.nav": "Navigation",
  "footer.contact": "Contact",
  "footer.hours": "Monday to Saturday · 8:00 am – 8:00 pm",
  "footer.legal": "© 2026 Facundo Yoldi · Home nursing. Maldonado and Punta del Este, Uruguay.",
  "footer.backTop": "Back to top",
};

export default en;